module.exports = __webpack_public_path__ + "static/img/104159.15694591.png";